import { render } from "./generalformcta.vue?vue&type=template&id=cd52c4b0&scoped=true"
import script from "./generalformcta.vue?vue&type=script&lang=js"
export * from "./generalformcta.vue?vue&type=script&lang=js"

import "./generalformcta.vue?vue&type=style&index=0&id=cd52c4b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd52c4b0"

export default script